import React from "react"

import SEO from "../../components/shared/SEO"
import TitleSection from "~components/pages/pims/specific/title"
import HowItWorksSection from "~components/pages/pims/specific/how-it-works"
import { RHAPSODY_COPY } from "~components/pages/pims/resources/rhapsody"
import BenefitsExplanation from "~components/pages/pims/specific/benefits-explanation"

export default function RhapsodyPage() {
    return (
        <>
            <TitleSection copy={RHAPSODY_COPY} />
            <BenefitsExplanation copy={RHAPSODY_COPY} />
            <HowItWorksSection copy={RHAPSODY_COPY} />
        </>
    )
}

export const Head = () => (
    <SEO 
        title="Rhapsody Integration & Two-Way Sync" 
        description="Complete Rhapsody veterinary software integration with two-way sync for automated scheduling, client communications, and practice analytics."
    />
)
